let textElements = document.querySelectorAll(".fade-text")
let imageElements = document.querySelectorAll(".image-animate")

function animateElements(elements) {
    setTimeout(function () {
        function animate() {
            for (let i = 0; i < elements.length; i++) {
                let fadeElem = elements[i]

                if (isElementInViewport(fadeElem) && !fadeElem.classList.contains("fade-show")) {
                    fadeElem.classList.add("fade-show")
                }
            }
        }

        animate()
        window.addEventListener("scroll", animate)
    }, 500)
}

if (textElements.length > 0) {
    animateElements(textElements)
}

if (imageElements.length > 0) {
    animateElements(imageElements)
}

function isElementInViewport(el: Element) {
    let rect = el.getBoundingClientRect()
    let viewportHeight = window.innerHeight || document.documentElement.clientHeight
    return (
        (rect.bottom > 0 && rect.top < 0) ||
        (rect.top >= 0 && rect.top + rect.height * 0.15 <= viewportHeight)
    )
}
